export const errorTypes = { not_found: 0, unknown: 1, forbidden: 2 };
